'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUBMISSION_CLEAR_ERROR = exports.SUBMISSION_CLEAR_ERROR = 'SUBMISSION_CLEAR_ERROR';
var SUBMISSION_REQUEST = exports.SUBMISSION_REQUEST = 'SUBMISSION_REQUEST';
var SUBMISSION_SAVE = exports.SUBMISSION_SAVE = 'SUBMISSION_SAVE';
var SUBMISSION_SUCCESS = exports.SUBMISSION_SUCCESS = 'SUBMISSION_SUCCESS';
var SUBMISSION_FAILURE = exports.SUBMISSION_FAILURE = 'SUBMISSION_FAILURE';
var SUBMISSION_RESET = exports.SUBMISSION_RESET = 'SUBMISSION_RESET';


//////////////////
// WEBPACK FOOTER
// ./~/react-formio/lib/modules/submission/constants.js
// module id = 865
// module chunks = 0